/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Viewer_Role_HostInputs */



/**
* | output |
* | --- |
* | "Host" |
*
* @param {Tournaments_Lib_Viewer_Role_HostInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_viewer_role_host = /** @type {((inputs?: Tournaments_Lib_Viewer_Role_HostInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Viewer_Role_HostInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Host")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Hôte")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("主办人")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("主辦方")
	if (locale === "ko") return /** @type {LocalizedString} */ ("주최")
	return /** @type {LocalizedString} */ ("Host")
});